'use client';
import React, { FC } from 'react';
import AmplienceDynamicComponent from '../dynamic-component';
export interface AmpliencePageProps {
  pageContent: {
    pageData: [any];
  };

  // Page SEO (title, description, canonical, index/follow) is read from the page-slot data source in
  // generateMetadata in app/[[...slug]]/page.tsx.
  seo?: {
    seoTitle?: string;
    seoDescription?: string;
    canonicalUrl?: string;
    index?: boolean;
    follow?: boolean;
  };
  [key: string]: any;
}

const AmpliencePage: FC<AmpliencePageProps> = (props) => {
  const { pageContent, ...restProps } = props;

  // Find cutoffs only when needed
  let lastTextIndex = -1;
  let plpPlaceholderIndex = -1;
  if (restProps.isPLP && restProps.hasSingleFacet) {
    const pageData = pageContent?.pageData ?? [];
    plpPlaceholderIndex = pageData.findIndex((comp: any) =>
      comp?.['_meta']?.schema?.includes('v2/content/plp-placeholder'),
    );

    // If no PLP placeholder for whatever reason, find last text component index as a fallback
    if (plpPlaceholderIndex === -1) {
      for (let i = pageData.length - 1; i >= 0; i -= 1) {
        if (pageData[i]?.['_meta']?.schema?.split('/').pop() === 'text') {
          lastTextIndex = i;
          break;
        }
      }
    }
  }

  return (
    <>
      {pageContent?.pageData?.map((component, index) => {
        const shouldHideAfterPlaceholder =
          restProps.isPLP && restProps.hasSingleFacet && plpPlaceholderIndex !== -1 && index > plpPlaceholderIndex;

        const isLastText =
          restProps.isPLP &&
          restProps.hasSingleFacet &&
          plpPlaceholderIndex === -1 &&
          component?.['_meta']?.schema?.split('/').pop() === 'text' &&
          index === lastTextIndex;

        // Hide last text component(s) when single facet selected on PLP
        if (shouldHideAfterPlaceholder || isLastText) {
          return null;
        }

        if (restProps.isPLP) {
          return (
            <AmplienceDynamicComponent key={'page-content-component-' + index} data={{ ...component }} {...restProps} />
          );
        }
        // For non-PLP pages, just render the component normally
        return <AmplienceDynamicComponent key={'page-content-component-' + index} data={{ ...component }} />;
      })}
    </>
  );
};

export default AmpliencePage;
